import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import GroupSelectionList from '../GroupSelectionList/GroupSelectionList';
import { SelectOptionTypes } from '../helper';
const GroupedList = _ref => {
  let {
    option,
    itemIndex,
    renderOption
  } = _ref;
  const {
    type
  } = option || {};
  const optionRef = useRef();
  if (type === SelectOptionTypes.GROUP_LIST) {
    let _options = option.items.map((item, idx) => renderOption(item, idx, option.type, optionRef));
    return /*#__PURE__*/React.createElement(GroupSelectionList, {
      key: option.name || itemIndex,
      title: option.title,
      defaultOpen: true
    }, _options);
  } else {
    return renderOption(option, itemIndex, '', optionRef);
  }
};
GroupedList.propTypes = {
  option: PropTypes.object.isRequired,
  itemIndex: PropTypes.number.isRequired,
  renderOption: PropTypes.func.isRequired
};
export default GroupedList;